export default "__VITE_ASSET__43c86a6e__"